import {
  B2C_POLICIES,
  LOGIN_ATTEMPT_KEY,
  PENDING_LOGOUT_KEY,
} from "@/shared/constants/auth.constants";

type AccountWithClaims = { idTokenClaims?: object } | null | undefined;

export const isPasswordResetAccount = (account: AccountWithClaims): boolean =>
  (account?.idTokenClaims as { acr?: string } | undefined)?.acr ===
  B2C_POLICIES.names.resetPassword;

type LoginAttempt = {
  correlationId: string;
  logoutId: string;
};

let pendingLogoutInMemory: string | null = null;
let loginAttemptInMemory: LoginAttempt | null = null;

const getPendingLogoutId = (): string | null => {
  if (pendingLogoutInMemory) {
    return pendingLogoutInMemory;
  }
  try {
    return localStorage.getItem(PENDING_LOGOUT_KEY);
  } catch {
    return null;
  }
};

export const hasPendingLogout = (): boolean => getPendingLogoutId() !== null;

export const markLogoutPending = (): void => {
  pendingLogoutInMemory = crypto.randomUUID();
  try {
    localStorage.setItem(PENDING_LOGOUT_KEY, pendingLogoutInMemory);
    pendingLogoutInMemory = null;
  } catch {
    return;
  }
};

export const recordLoginAttempt = (correlationId: string): void => {
  const logoutId = getPendingLogoutId();
  if (!logoutId) {
    return;
  }
  loginAttemptInMemory = { correlationId, logoutId };
  try {
    sessionStorage.setItem(
      LOGIN_ATTEMPT_KEY,
      JSON.stringify(loginAttemptInMemory),
    );
  } catch {
    return;
  }
};

export const completeLoginAttempt = (correlationId: string): boolean => {
  let attempt = loginAttemptInMemory;
  try {
    const storedAttempt = sessionStorage.getItem(LOGIN_ATTEMPT_KEY);
    if (storedAttempt) {
      attempt = JSON.parse(storedAttempt) as LoginAttempt;
    }
  } catch {
    return false;
  }

  if (
    !attempt ||
    attempt.correlationId !== correlationId ||
    attempt.logoutId !== getPendingLogoutId()
  ) {
    return false;
  }

  try {
    localStorage.removeItem(PENDING_LOGOUT_KEY);
    pendingLogoutInMemory = null;
  } catch {
    return false;
  }

  loginAttemptInMemory = null;
  try {
    sessionStorage.removeItem(LOGIN_ATTEMPT_KEY);
  } catch {
    return true;
  }
  return true;
};
